module.exports = __webpack_public_path__ + "static/media/mozza-mb-2023-en.4bd9c837.jpg";